export const SEB_TEST_DATA = {
  "questions": [
    {
      "id": 1,
      "axis": "S",
      "weight": 1.5,
      "q": {
        "ko": "중요한 발표 직전, 갑자기 노트북이 고장 나서 자료가 뜨지 않는다면?",
        "en": "Just before an important presentation, your laptop suddenly breaks and the materials won't open. What would you do?"
      },
      "a": {
        "ko": [
          "당황스럽지만 즉시 해결 방법을 찾아야 한다는 생각에 몸이 먼저 움직인다.",
          "기기에 문제가 생긴 것에 짜증이 나지만, 일단 주변의 도움이나 장비를 빌릴 곳을 찾는다.",
          "잠시 심호흡을 하며 머릿속으로 전체 발표 흐름을 다시 한번 정리해 본다.",
          "자료 없이도 핵심 내용은 전달할 수 있도록 마음을 다듬고 대안을 실행한다."
        ],
        "en": [
          "Though flustered, your body moves immediately to find a solution.",
          "Irritated by the technical issue, you first look for help or a place to borrow equipment.",
          "Take a deep breath and mentally reorganize the entire presentation flow.",
          "Compose yourself and execute an alternative to deliver the key points even without the materials."
        ]
      },
      "category": "Core"
    },
    {
      "id": 2,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "식당에서 주문한 음식이 설명도 없이 40분째 나오지 않을 때 당신은?",
        "en": "When the food you ordered at a restaurant hasn't come out for 40 minutes without any explanation, what do you do?"
      },
      "a": {
        "ko": [
          "기다리는 시간이 한계에 도달했다고 느껴 직원에게 상황을 직접 확인한다.",
          "시간이 아깝다는 생각이 들어 취소하고 나갈지, 더 기다릴지 동행인과 의논한다.",
          "매장이 바빠 보여서 그럴 수 있다고 생각하며 조용히 순서를 기다린다.",
          "함께 온 사람과의 대화에 집중하느라 시간이 이렇게 흐른 줄 몰랐다."
        ],
        "en": [
          "Feel like your patience has reached its limit and personally check the situation with the staff.",
          "Thinking it's a waste of time, discuss with your companion whether to cancel and leave or wait longer.",
          "Think it might be because the place looks busy and wait quietly in order.",
          "Was so focused on the conversation with your companion that you didn't realize how much time had passed."
        ]
      },
      "category": "Core"
    },
    {
      "id": 3,
      "axis": "S",
      "weight": 1.5,
      "q": {
        "ko": "누군가 많은 사람들 앞에서 나의 실수를 공개적으로 지적한다면?",
        "en": "What if someone publicly points out your mistake in front of many people?"
      },
      "a": {
        "ko": [
          "상대의 무례함에 불쾌함을 느끼고, 그 지적이 타당한지 논리적으로 따져본다.",
          "갑작스러운 상황에 당황스럽고 화가 나지만, 나중에 어떻게 대응할지 고민한다.",
          "일단 지금의 상황을 빠르게 수용하고, 실수를 바로잡는 것에 우선순위를 둔다.",
          "상대의 태도에 크게 휘둘리지 않고 내 할 일과 페이스를 유지하려 노력한다."
        ],
        "en": [
          "Feel offended by the person's rudeness and logically evaluate whether the criticism is valid.",
          "Flustered and angry at the sudden situation, but think about how to respond later.",
          "First, quickly accept the current situation and prioritize correcting the mistake.",
          "Try to maintain your pace and carry on with your work without being heavily swayed by the person's attitude."
        ]
      },
      "category": "Core"
    },
    {
      "id": 4,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "운전 중 갑자기 뒷차가 무리하게 끼어들어 사고가 날 뻔했다면?",
        "en": "What if a car behind you suddenly cuts in recklessly while driving, almost causing an accident?"
      },
      "a": {
        "ko": [
          "너무 위험한 행동이라 생각되어 경적을 울리거나 불쾌함을 즉각 표현한다.",
          "깜짝 놀란 가슴이 진정되지 않아 한동안 그 차의 번호나 운전자의 태도를 곱씹는다.",
          "깜짝 놀랐지만 금방 평정심을 되찾고 평소처럼 안전 운전에 집중한다.",
          "운전하다 보면 생길 수 있는 일이라 생각하고 바로 하던 생각이나 음악에 집중한다."
        ],
        "en": [
          "Thinking it's very dangerous behavior, honk the horn or immediately express your displeasure.",
          "So startled that your heart won't settle, you ruminate on the car's plate number or the driver's attitude for a while.",
          "Startled, but quickly regain your composure and focus on safe driving as usual.",
          "Think of it as something that can happen while driving and immediately focus back on your thoughts or music."
        ]
      },
      "category": "Core"
    },
    {
      "id": 5,
      "axis": "S",
      "weight": 1.5,
      "q": {
        "ko": "공들여 준비한 프로젝트가 예상치 못한 외부 이유로 무산되었다면?",
        "en": "If a project you prepared with great effort falls through due to unexpected external reasons, how would you feel?"
      },
      "a": {
        "ko": [
          "큰 아쉬움과 허탈함이 커서 결과가 확정된 뒤 잠시 혼자만의 시간을 갖는다.",
          "그동안의 노력이 아까워 지인들에게 상황을 털어놓으며 감정을 해소한다.",
          "아쉬운 마음은 들지만, 무엇이 문제였는지 객관적인 원인을 먼저 파악한다.",
          "이미 벌어진 일이니 미련을 두기보다 다음 기회나 다른 계획에 바로 집중한다."
        ],
        "en": [
          "Feeling deep regret and a sense of emptiness, you spend some time alone after the result is finalized.",
          "Thinking it's a waste of all that effort, you vent your feelings by telling friends about the situation.",
          "While feeling regretful, you first identify the objective causes of the problem.",
          "Since it has already happened, you immediately focus on the next opportunity or another plan rather than lingering on it."
        ]
      },
      "category": "Core"
    },
    {
      "id": 6,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "층간 소음이나 주변 소란 때문에 며칠째 잠을 설치고 있다면?",
        "en": "If you've been losing sleep for several days due to noise from neighbors or surrounding commotions, what would you do?"
      },
      "a": {
        "ko": [
          "참는 것에 한계를 느껴 직접 연락하거나 관리실에 시정을 강력히 요구한다.",
          "소리가 들릴 때마다 신경이 곤두서서 다른 일에 집중하기가 어렵다.",
          "귀마개를 쓰거나 백색 소음을 틀어 스스로 환경을 통제하려 노력한다.",
          "소음이 며칠 계속되어도 '언젠간 멈추겠지' 하며 무덤덤하게 잠을 청한다."
        ],
        "en": [
          "Reaching the limit of your patience, you personally contact them or strongly demand corrective action from the management office.",
          "Your nerves are on edge every time you hear the sound, making it difficult to concentrate on other things.",
          "Try to control the environment yourself by using earplugs or playing white noise.",
          "Even if the noise continues for days, you calmly try to sleep, thinking 'it'll stop eventually.'"
        ]
      },
      "category": "Core"
    },
    {
      "id": 7,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "믿었던 사람이 나에게 사소한 거짓말을 했다는 사실을 알게 된다면?",
        "en": "What if you find out that someone you trusted told you a minor lie?"
      },
      "a": {
        "ko": [
          "왜 거짓말을 했는지 직접 물어보고, 그 이유가 납득 가능한지 확인해야 직성이 풀린다.",
          "상대에게 배신감을 느껴 한동안 그 사람과의 관계에 대해 깊이 고민하게 된다.",
          "상황에 따라 그럴 수도 있었다고 생각하며 일단은 지켜보기로 한다.",
          "사소한 일이라면 크게 개의치 않고 이전과 다름없는 태도로 상대를 대한다."
        ],
        "en": [
          "Personally ask why they lied and ensure the reason is acceptable to feel satisfied.",
          "Feeling betrayed, you deeply reconsider your relationship with that person for a while.",
          "Think they might have had their reasons depending on the situation and decide to wait and see for now.",
          "Don't mind much if it's a minor thing and treat the person with the same attitude as before."
        ]
      },
      "category": "Core"
    },
    {
      "id": 8,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "내가 탄 버스가 기사의 운전 미숙으로 계속 심하게 덜컹거린다면?",
        "en": "What if the bus you're on keeps rattling severely due to the driver's poor driving?"
      },
      "a": {
        "ko": [
          "승객들의 안전이 걱정되어 기사님께 주의를 드려야 할지 진지하게 고민한다.",
          "불안하고 어지러워서 내릴 때까지 손잡이를 꽉 잡고 계속 불쾌해한다.",
          "길이 험하거나 차가 낡았을 거라 생각하며 목적지까지 묵묵히 간다.",
          "차가 덜컹거리든 말든 스마트폰 화면이나 책, 생각에 완전히 몰입한다."
        ],
        "en": [
          "Worried about the passengers' safety, you seriously consider whether to caution the driver.",
          "Anxious and dizzy, you hold the handle tightly until you get off and remain displeased.",
          "Think it's because the road is rough or the bus is old and go silently to the destination.",
          "Completely immerse yourself in your smartphone screen, a book, or your thoughts regardless of the bus rattling."
        ]
      },
      "category": "Core"
    },
    {
      "id": 9,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "주말 계획을 다 세워뒀는데, 갑작스러운 상대의 약속 취소로 무산되었다면?",
        "en": "What if you had all your weekend plans set, but they fell through because the other person suddenly cancelled?"
      },
      "a": {
        "ko": [
          "상대의 배려 없는 태도에 화가 나고, 그 점을 명확히 지적하고 싶어진다.",
          "계획이 틀어진 것에 맥이 빠져서 남은 하루 동안 딱히 아무것도 하고 싶지 않다.",
          "잠시 당황하지만, 혼자서 할 수 있는 다른 일을 찾아 알차게 시간을 보낸다.",
          "오히려 편하게 쉴 수 있는 시간이 생겼다고 긍정적으로 생각하며 하루를 즐긴다."
        ],
        "en": [
          "Angry at the person's inconsiderate attitude, you feel like clearly pointing it out.",
          "De-energized by the plans being ruined, you don't really want to do anything for the rest of the day.",
          "Flustered for a moment, but find something else you can do alone and spend the time productively.",
          "Positively think that you now have time to rest comfortably and enjoy the day."
        ]
      },
      "category": "Core"
    },
    {
      "id": 10,
      "axis": "S",
      "weight": 1,
      "q": {
        "ko": "게임이나 내기에서 억울한 판정으로 패배하게 된다면?",
        "en": "What if you lose a game or a bet due to an unfair ruling?"
      },
      "a": {
        "ko": [
          "결과를 받아들일 수 없어 판정의 부당함을 조목조목 따진다.",
          "화가 가라앉지 않아 감정을 그대로 표현하며 분위기를 주도한다.",
          "억울한 면은 있지만 결과가 나왔으니 다음 기회를 기약하며 마무리한다.",
          "승패 자체보다 그동안 즐거웠던 과정에 만족하며 웃고 넘긴다."
        ],
        "en": [
          "Unable to accept the result, you argue the unfairness of the ruling point by point.",
          "Unable to calm your anger, you express your emotions and lead the atmosphere.",
          "Though it's unfair, you accept that the result is out and wrap it up, looking forward to the next opportunity.",
          "Satisfied with the enjoyable process rather than the win or loss itself, you laugh it off."
        ]
      },
      "category": "Core"
    },
    {
      "id": 11,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "친구가 고민을 털어놓으며 내 앞에서 눈물을 보인다면?",
        "en": "What if a friend confides their troubles and sheds tears in front of you?"
      },
      "a": {
        "ko": [
          "친구의 상황을 냉정하게 보고, 근본적인 문제를 해결할 수 있는 조언을 해준다.",
          "일단 친구가 울음을 그칠 수 있도록 달래주거나 필요한 것을 챙겨준다.",
          "아무 말 없이 곁에 있어 주는 것이 최선이라 생각하여 가만히 들어준다.",
          "친구가 느끼는 감정이 그대로 전달되어 진심으로 같이 마음 아파한다."
        ],
        "en": [
          "Objectively analyze your friend's situation and give advice to solve the fundamental problem.",
          "First, soothe your friend so they can stop crying or provide them with what they need.",
          "Thinking that being by their side in silence is the best thing, you just listen quietly.",
          "Your friend's emotions are directly transmitted to you, and you sincerely feel their pain together."
        ]
      },
      "category": "Core"
    },
    {
      "id": 12,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "회의 중 의견 충돌로 분위기가 갑자기 무겁고 싸해졌을 때 나는?",
        "en": "When the atmosphere in a meeting suddenly becomes heavy and cold due to a conflict of opinions, what do you do?"
      },
      "a": {
        "ko": [
          "분위기와 상관없이 논의가 중단되지 않도록 할 말을 정확히 이어간다.",
          "불편한 기류는 느껴지지만, 내 감정을 섞지 않고 업무적인 부분만 본다.",
          "누가 왜 기분이 상했는지 살피며 분위기를 추스를 방법을 고민한다.",
          "가벼운 농담이나 부드러운 화법으로 굳어 있는 팀원들의 긴장을 풀어준다."
        ],
        "en": [
          "Regardless of the atmosphere, carry on with what you have to say accurately so the discussion doesn't stop.",
          "While feeling the uncomfortable air, you only look at the work aspect without involving your emotions.",
          "Observe who is upset and why, and think about ways to smooth over the atmosphere.",
          "Use light jokes or a gentle way of speaking to ease the tension of the stiffened team members."
        ]
      },
      "category": "Core"
    },
    {
      "id": 13,
      "axis": "E",
      "weight": 1.5,
      "q": {
        "ko": "다큐멘터리에서 극심한 어려움에 처한 아이들의 모습을 본다면?",
        "en": "What if you see children in extreme hardship in a documentary?"
      },
      "a": {
        "ko": [
          "현실의 안타까운 문제라고 인식하지만, 내 일상과 감정을 분리하려 한다.",
          "어떤 도움을 줄 수 있는지 알아보고 실제적인 행동(기부 등)을 고민한다.",
          "아이들의 표정이 며칠 동안 기억에 남아 내 삶에 대해 성찰하게 된다.",
          "영상을 보는 내내 가슴이 미어지고, 마치 내 일이 된 것처럼 깊이 슬퍼한다."
        ],
        "en": [
          "Recognize it as an unfortunate reality but try to separate it from your daily life and emotions.",
          "Look into what kind of help you can provide and consider practical actions (donations, etc.).",
          "The children's expressions stay in your memory for days, leading you to reflect on your own life.",
          "Your heart aches throughout the video, and you feel deep sadness as if it were your own situation."
        ]
      },
      "category": "Core"
    },
    {
      "id": 14,
      "axis": "E",
      "weight": 1.5,
      "q": {
        "ko": "상대방이 나를 칭찬하는데 표정이 묘하게 어색하다고 느낀다면?",
        "en": "What if someone praises you, but you feel their expression is strangely awkward?"
      },
      "a": {
        "ko": [
          "칭찬의 내용 자체가 논리적으로 맞다면 그 의도는 크게 개의치 않는다.",
          "단순히 그 사람이 표현을 잘 못 하는 성격이라고만 생각하고 넘긴다.",
          "이 사람이 진심으로 좋아서 하는 말인지, 빈말인지 직감적으로 알아챈다.",
          "칭찬 속에 담긴 상대의 미묘한 시기심이나 다른 속내까지 느끼게 된다."
        ],
        "en": [
          "If the content of the praise is logically correct, you don't really mind the intention behind it.",
          "Just think the person has a personality that's not good at expressing themselves and move on.",
          "Instinctively know whether the person is saying it out of sincerity or just lip service.",
          "Feel the person's subtle envy or other hidden agendas within the praise."
        ]
      },
      "category": "Core"
    },
    {
      "id": 15,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "친구가 고민을 말하는데, 듣고 보니 친구의 잘못이 명확하다면?",
        "en": "When a friend tells you their trouble, and it's clear after listening that it's their own fault, what do you do?"
      },
      "a": {
        "ko": [
          "친구를 위해서라도 무엇이 잘못되었는지 정확하게 지적하고 바로잡아준다.",
          "친구가 스스로 깨달을 수 있도록 옆에서 들어주며 지켜봐 준다.",
          "먼저 친구의 서운하거나 속상했을 마음을 충분히 공감해준 뒤 말을 꺼낸다.",
          "친구의 잘못 이면에 있었을 두려움이나 복잡한 사연까지 깊이 이해해준다."
        ],
        "en": [
          "For your friend's sake, accurately point out what's wrong and correct it.",
          "Listen and watch by their side so your friend can realize it for themselves.",
          "First fully empathize with your friend's feelings of being hurt or upset, and then speak your mind.",
          "Deeply understand the fear or complex stories that might have been behind your friend's mistake."
        ]
      },
      "category": "Core"
    },
    {
      "id": 16,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "작품 속 캐릭터의 행동이 상식적으로 전혀 이해되지 않을 때 나는?",
        "en": "When a character's actions in a work are completely incomprehensible to common sense, what do you do?"
      },
      "a": {
        "ko": [
          "스토리 설정에 구멍이 있다고 생각하여 비판적인 관점으로 분석한다.",
          "가상의 이야기니 그럴 수 있다고 보고 크게 의미를 두지 않는다.",
          "그 인물의 과거사나 환경이 그런 선택을 하게 만들었을지 고민해본다.",
          "그 캐릭터의 감정선을 따라가다 보면 그 기분을 어느 정도 공감하게 된다."
        ],
        "en": [
          "Thinking there's a hole in the story setup, analyze it from a critical perspective.",
          "Viewing it as just a fictional story, think it's possible and don't place much meaning on it.",
          "Consider whether the character's past or environment might have led them to make such a choice.",
          "While following the character's emotional arc, you end up empathizing with their feelings to some extent."
        ]
      },
      "category": "Core"
    },
    {
      "id": 17,
      "axis": "E",
      "weight": 1.5,
      "q": {
        "ko": "중요한 협상 자리에서 상대방이 무리한 조건을 제시한다면?",
        "en": "What if the other party presents unreasonable terms in an important negotiation meeting?"
      },
      "a": {
        "ko": [
          "내가 감당할 수 있는 선을 넘었다면 즉시 거절하고 내 조건을 강하게 밀붙인다.",
          "상대의 요구를 수치화하여 우리에게 유리한지 실익만을 꼼꼼히 계산한다.",
          "답변하는 상대의 목소리 톤이나 시선을 통해 그가 얼마나 절박한지 읽는다.",
          "상대가 원하는 실질적인 보상과 그가 중요하게 생각하는 가치를 동시에 파악한다."
        ],
        "en": [
          "If it has crossed the line of what you can handle, immediately reject it and push through with your own terms strongly.",
          "Quantify the other party's demands and meticulously calculate only the practical benefits for your side.",
          "Read how desperate they are through the tone of their voice or their gaze as they answer.",
          "Identify both the practical compensation the other party wants and the values they consider important."
        ]
      },
      "category": "Core"
    },
    {
      "id": 18,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "누군가 농담을 던졌는데, 그 속에 뼈가 있는 것처럼 느껴진다면?",
        "en": "What if someone makes a joke, but you feel it has a hidden sting?"
      },
      "a": {
        "ko": [
          "표면적인 농담에만 맞춰 대응하고, 그 이면의 의미는 신경 쓰지 않는다.",
          "말의 의도가 헷갈려도 굳이 깊게 파고들지 않고 무시하는 편이다.",
          "나를 은근히 견제하거나 비꼬고 있다는 사실을 예리하게 감지한다.",
          "그 사람이 왜 그런 식으로 말할 수밖에 없는지 그의 불안한 심리까지 이해된다."
        ],
        "en": [
          "Respond only to the superficial joke and don't care about the meaning behind it.",
          "Even if the intention of the words is confusing, you tend to ignore it without digging deep.",
          "Keenly sense the fact that they are subtly checking or mocking you.",
          "Understand why they have no choice but to speak that way, including their anxious psychology."
        ]
      },
      "category": "Core"
    },
    {
      "id": 19,
      "axis": "E",
      "weight": 1,
      "q": {
        "ko": "타인이 사람들 앞에서 큰 실수를 하여 망신을 당하는 걸 본다면?",
        "en": "What if you see someone made a big mistake in front of people and being humiliated?"
      },
      "a": {
        "ko": [
          "그 사람의 실수를 단순히 상황적인 일로 여기며 가볍게 생각한다.",
          "내가 직접 도와줄 수 있는 일이 아니라고 판단하면 무관심한 태도를 갖는다.",
          "그가 느낄 수치심이 짐작되어 내가 더 민망해져서 고개를 돌리게 된다.",
          "그 사람이 겪는 심리적 타격이 내 일처럼 고스란히 느껴져 힘들다."
        ],
        "en": [
          "Think of the person's mistake as just a situational thing and don't place much meaning on it.",
          "Being indifferent if you judge it's not something you can directly help with.",
          "Guessing the shame they must be feeling, you feel more embarrassed yourself and turn your head away.",
          "The psychological blow the person is suffering feels like your own, which makes it hard for you."
        ]
      },
      "category": "Core"
    },
    {
      "id": 20,
      "axis": "E",
      "weight": 1.5,
      "q": {
        "ko": "모임에서 사람들이 특정 대화 주제를 피하는 기류를 느꼈을 때?",
        "en": "What if you sense an air of people avoiding a specific conversation topic in a meeting?"
      },
      "a": {
        "ko": [
          "분위기를 환기하기 위해 궁금한 점을 직접 물어보며 화제를 전환한다.",
          "상황을 지켜보다가 가장 편안한 사람에게 따로 조용히 이유를 묻는다.",
          "사람들 사이의 묘한 시선 교환이나 침묵을 보며 과거의 사건을 추측해본다.",
          "말하지 않아도 그들 사이에 얽혀 있는 보이지 않는 사정들을 본능적으로 느낀다."
        ],
        "en": [
          "Personally ask about what you're curious about to refresh the atmosphere and change the topic.",
          "Watching the situation, quietly ask the person you're most comfortable with about the reason later.",
          "Observe the subtle exchange of glances or the silence between people and speculate about past events.",
          "Instinctively feel the invisible circumstances intertwined between them without any words being said."
        ]
      },
      "category": "Core"
    },
    {
      "id": 21,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "오늘 꼭 운동하기로 결심했는데, 퇴근 후에 몸이 너무 피곤하다면?",
        "en": "You were determined to exercise today, but you feel very tired after work. What would you do?"
      },
      "a": {
        "ko": [
          "내 몸의 컨디션을 가장 우선하여 오늘은 푹 쉬는 것을 선택한다.",
          "운동을 못 한 것에 마음이 편치 않아 대체할 수 있는 스트레칭이라도 한다.",
          "피곤하긴 하지만 정해둔 루틴의 절반이라도 달성하기 위해 몸을 일으킨다.",
          "피곤함은 일시적이라 생각하고 결심한 계획을 무조건 완수한다."
        ],
        "en": [
          "Choose to have a good rest today, prioritizing your body's condition.",
          "Not feeling comfortable about missing the exercise, you at least do some stretching as a substitute.",
          "Although tired, you get up to achieve at least half of the planned routine.",
          "Thinking that fatigue is temporary, you unconditionally complete the planned goal."
        ]
      },
      "category": "Core"
    },
    {
      "id": 22,
      "axis": "F",
      "weight": 1.5,
      "q": {
        "ko": "새벽 2시, 보는 이가 아무도 없는 횡단보도 빨간불 앞에 서 있다면?",
        "en": "It's 2 AM and you're standing in front of a red light at a crosswalk with no one watching. What do you do?"
      },
      "a": {
        "ko": [
          "차도 사람도 전혀 없어 안전하다는 판단이 들면 길을 건넌다.",
          "다른 사람이 먼저 건너가면 그 흐름에 따라 자연스럽게 따라간다.",
          "신호를 지켜야 한다고 생각하지만, 주변 상황에 따라 갈등이 생긴다.",
          "지켜보는 눈이 없어도 약속된 규칙을 어기는 것에 큰 불편함을 느껴 대기한다."
        ],
        "en": [
          "If you judge it's safe because there are neither cars nor people, you cross the street.",
          "If someone else crosses first, you naturally follow that flow.",
          "Agree that the signal should be obeyed, but feel conflicted depending on the surrounding situation.",
          "Even without a watchful eye, you feel great discomfort in breaking a promised rule and wait."
        ]
      },
      "category": "Core"
    },
    {
      "id": 23,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "취미를 시작했는데 생각보다 결과물이 좋지 않아 실망스럽다면?",
        "en": "You started a hobby, but you're disappointed because the result isn't as good as expected. What do you do?"
      },
      "a": {
        "ko": [
          "나와는 맞지 않는 일이라 판단하고 더 즐길 수 있는 다른 일을 찾는다.",
          "투자한 시간과 비용이 아깝지만, 일단은 좀 더 상황을 지켜보기로 한다.",
          "애초에 계획했던 목표치까지는 계속 시도하며 부족한 점을 보완한다.",
          "결과와 상관없이 '한 번 선택한 것은 끝까지 해낸다'는 원칙을 위해 마친다."
        ],
        "en": [
          "Judging that it's not the right thing for you, you look for something else you can enjoy more.",
          "Thinking of the wasted time and money, you decide to wait and see the situation a bit longer for now.",
          "Continuously try to reach the initially planned goal while making up for deficiencies.",
          "Regardless of the result, you finish it for the principle of 'completing once selected.'"
        ]
      },
      "category": "Core"
    },
    {
      "id": 24,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "다이어트 중인데, 친구가 내가 가장 좋아하는 간식을 사 왔다면?",
        "en": "You're on a diet, but a friend bought your favorite snack. What do you do?"
      },
      "a": {
        "ko": [
          "친구의 성의를 무시할 수 없으니 즐겁게 먹고 내일부터 다시 조절한다.",
          "처음엔 거절하지만 친구가 권하면 못 이기는 척 적당히 함께 먹는다.",
          "맛만 살짝 보는 정도로 타협하며 친구와의 관계와 내 목표를 절충한다.",
          "내 건강과 목표가 우선이기에 고맙지만 단호하게 정중히 사양한다."
        ],
        "en": [
          "Unable to ignore your friend's kindness, you enjoy it and resume your diet from tomorrow.",
          "Refuse at first, but eat a moderate amount with your friend as if you've been persuaded.",
          "Compromise by just having a small taste, balancing the relationship and your goal.",
          "Politely but firmly decline because your health and goal are the priority."
        ]
      },
      "category": "Core"
    },
    {
      "id": 25,
      "axis": "F",
      "weight": 1.5,
      "q": {
        "ko": "상사가 부적절한 지시를 내리며 나에게 개인적인 혜택을 제안한다면?",
        "en": "If your boss gives inappropriate instructions and offers you personal benefits, what do you do?"
      },
      "a": {
        "ko": [
          "현실적으로 나에게 득이 되는 선택이라 판단되면 제안을 받아들인다.",
          "거절했을 때의 후폭풍을 고려하여 일단은 긍정적으로 검토하는 시늉을 한다.",
          "마음이 불편하지만 바로 거절하진 못하고 시간을 끌며 대책을 세운다.",
          "나의 양심과 원칙이 더 중요하기에 어떤 혜택이 있더라도 단호히 거절한다."
        ],
        "en": [
          "Accept the offer if you judge it to be a pragmatically beneficial choice for you.",
          "Considering the aftermath of a refusal, pretend to review it positively for now.",
          "Feeling uncomfortable but unable to refuse immediately, you stall for time while devising a plan.",
          "Firmly refuse regardless of any benefits because your conscience and principles are more important."
        ]
      },
      "category": "Core"
    },
    {
      "id": 26,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "친구의 이사를 도와주기로 했는데, 막상 당일이 되니 너무 귀찮다면?",
        "en": "You promised to help a friend move, but on the actual day, you feel very unmotivated. What do you do?"
      },
      "a": {
        "ko": [
          "내 컨디션이 좋지 않음을 설명하고 다른 보답을 약속하며 약속을 미룬다.",
          "가기 싫은 마음이 크지만 약속을 했기에 늦게라도 무거운 발걸음을 옮긴다.",
          "귀찮음보다 이미 한 약속에 대한 책임감을 더 크게 느껴 몸을 움직인다.",
          "상대와의 신뢰는 반드시 지켜야 할 가치라고 생각하며 즐겁게 임하려 노력한다."
        ],
        "en": [
          "Explain your poor condition and postpone the promise while promising another way to repay them.",
          "Reluctant to go but taking heavy steps even if late because you made a promise.",
          "Feeling a greater sense of responsibility for the promise than for the lack of motivation, you move your body.",
          "Thinking that trust with others is an essential value to keep, you try to engage cheerfully."
        ]
      },
      "category": "Core"
    },
    {
      "id": 27,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "지인에게 빌린 돈을 갚기로 한 날짜가 지났는데, 그가 잊은 듯하다면?",
        "en": "The date to repay the money borrowed from an acquaintance has passed, but they seem to have forgotten. What do you do?"
      },
      "a": {
        "ko": [
          "상대가 먼저 말하지 않는 것을 기회로 여기며 일단 상황을 지켜본다.",
          "나중에 여유가 생기면 그때 건네야겠다고 생각하며 현재 내 일에 쓴다.",
          "갚아야 한다는 사실에 마음이 계속 쓰여 돌려줄 기회를 호시탐탐 노린다.",
          "상대가 잊었든 말든 정해진 날짜가 되었으니 즉시 연락하여 먼저 송금한다."
        ],
        "en": [
          "Regarding it as an opportunity that the other person hasn't spoken first, you observe the situation for now.",
          "Thinking of returning it later when you have more cushion, you use the money for your current work.",
          "Continuously feeling uneasy about the fact that you have to repay it, you keep looking for a chance to return it.",
          "Since the set date has arrived regardless of whether they forgot, you immediately contact them and send the money first."
        ]
      },
      "category": "Core"
    },
    {
      "id": 28,
      "axis": "F",
      "weight": 1.5,
      "q": {
        "ko": "주변에서 어렵다고 말하는 목표에 내가 도전하고 있다면?",
        "en": "You are challenging a goal that those around you say is difficult. How do you respond?"
      },
      "a": {
        "ko": [
          "주변의 현실적인 조언들을 참고하여 불가능해 보이면 계획을 유연하게 수정한다.",
          "남들이 불가능하다고 말하면 내 선택에 대해 계속 의구심이 생겨 흔들린다.",
          "남들의 시선보다는 일단 내가 할 수 있는 최선의 노력을 다하며 결과를 기다린다.",
          "나의 선택이 옳다는 것을 증명하기 위해 외부의 우려를 동력 삼아 전진한다."
        ],
        "en": [
          "Referring to realistic advice from those around you, you flexibly modify the plan if it seems impossible.",
          "If others say it's impossible, you keep having doubts about your choice and feel shaken.",
          "Regardless of others' views, you first do your best and wait for the results.",
          "To prove that your choice is right, you move forward using external concerns as motivation."
        ]
      },
      "category": "Core"
    },
    {
      "id": 29,
      "axis": "F",
      "weight": 1.5,
      "q": {
        "ko": "내 실수를 솔직히 인정할 경우 금전적/시간적 손해를 봐야 한다면?",
        "en": "What if admitting your mistake honestly means you will suffer financial or temporal loss?"
      },
      "a": {
        "ko": [
          "내 실수가 드러나지 않을 확률이 높다면 조용히 수습하고 넘어간다.",
          "상대방이 문제를 제기하기 전까지는 굳이 먼저 나서서 밝히지 않는다.",
          "상황에 따라 내 잘못을 일부 인정하되 나에게 최대한 유리한 협상을 한다.",
          "손해를 보더라도 정직함과 신뢰를 지키는 것이 내 삶의 원칙이기에 즉시 밝힌다."
        ],
        "en": [
          "If there's a high chance your mistake won't be revealed, you quietly handle it and move on.",
          "Unless the other person raises a problem, you don't really come forward to reveal it first.",
          "Partially acknowledge your fault depending on the situation while negotiating to your maximum advantage.",
          "Immediately reveal it because keeping honesty and trust is my life principle even if I suffer a loss."
        ]
      },
      "category": "Core"
    },
    {
      "id": 30,
      "axis": "F",
      "weight": 1,
      "q": {
        "ko": "내일부터 아침 일찍 일어나기로 결심한 첫날, 휴대폰 알람이 울린다면?",
        "en": "On the first day of your determination to wake up early from tomorrow, the phone alarm rings. What do you do?"
      },
      "a": {
        "ko": [
          "잠이 부족하다고 느껴지면 무리하게 일어나는 것보다 휴식을 더 취한다.",
          "알람을 끄고 5분만 더 자는 것을 반복하며 본능에 충실한 시간을 보낸다.",
          "정신력으로 눈을 뜨고, 결심한 계획을 시작하기 위해 천천히 일어난다.",
          "알람 소리가 들리자마자 망설임 없이 즉각 침대에서 일어나 하루를 시작한다."
        ],
        "en": [
          "If you feel lacking in sleep, you take more rest rather than forcing yourself to get up.",
          "Turn off the alarm and sleep for 5 more minutes repeatedly, spending time faithful to instinct.",
          "Open your eyes with willpower and get up slowly to start the determined plan.",
          "As soon as the alarm rings, get out of bed immediately without hesitation and start the day."
        ]
      },
      "category": "Core"
    }
  ],
  "results": [
    {
      "type_code": "HHH",
      "name": "Type HHH",
      "summary": "당신은 관계에서 안정적인 흐름을 유지하려는 경향이 있습니다. 갈등이나 감정이 흔들리는 상황에서도 바로 감정적으로 반응하기보다 상황을 먼저 정리하려 할 때가 많고, 상대의 감정이나 분위기 변화를 살피면서 대화를 통해 문제를 풀어보려 하는 경우가 많습니다. 그래서 관계에서 문제가 생겨도 쉽게 포기하기보다 해결하려는 방향으로 움직이는 경향이 있습니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 관계에서 안정적인 흐름을 유지하려는 경향이 있습니다. 갈등이나 감정이 흔들리는 상황에서도 바로 감정적으로 반응하기보다 상황을 먼저 정리하려 할 때가 많고, 상대의 감정이나 분위기 변화를 살피면서 대화를 통해 문제를 풀어보려 하는 경우가 많습니다. 그래서 관계에서 문제가 생겨도 쉽게 포기하기보다 해결하려는 방향으로 움직이는 경향이 있습니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "이런 상황이 반복되면 관계의 균형이 깨질 수 있습니다. 모든 문제를 혼자 해결하려 하기보다는 서로 역할을 나누는 것이 필요할 때도 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 신뢰와 안정적인 관계를 중요하게 생각합니다. 가볍게 이어지는 관계보다는 서로 책임을 공유하는 관계를 선호하는 편입니다.",
        "psychological_basis": "이 유형은 서로 감정을 솔직하게 이야기하면서도 관계가 쉽게 흔들리지 않는 환경에서 편안함을 느끼는 경우가 많습니다. 서로 책임을 나누고 신뢰가 유지되는 관계에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "다만 이런 태도는 때로 너무 많은 책임을 떠안는 모습으로 보일 수 있습니다. 문제를 해결하려는 의지가 강하다 보니 상대의 문제까지 스스로 해결하려는 경향이 나타날 수 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 차분하면서도 믿을 수 있는 사람으로 보일 가능성이 큽니다. 관계가 흔들릴 때 중심을 잡고 상황을 정리하려는 모습 때문에 안정감을 주는 사람으로 인식되는 경우가 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HHM",
      "name": "Type HHM",
      "summary": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 평정심을 잘 유지하며 안정적인 장점을 살리되, 타인의 감정을 깊게 공감한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 평정심을 잘 유지하며 안정적함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 타인의 감정을 깊게 공감함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 평정심을 잘 유지하며 안정적인 면이 강조되어 타인의 감정을 깊게 공감한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 평정심을 잘 유지하며 안정적이면서도 타인의 감정을 깊게 공감한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HHL",
      "name": "Type HHL",
      "summary": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 상대의 감정을 이해하려는 경향이 있습니다. 갈등이 생겨도 감정적으로 바로 반응하기보다 상황을 먼저 정리하려 할 때가 많고, 상대가 왜 그런 반응을 보였는지 이해하려는 경우가 많습니다. 다만 관계를 반드시 유지해야 한다고 생각하기보다는 상황이 맞지 않다고 느껴지면 관계를 정리하는 선택을 하기도 합니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 상대의 감정을 이해하려는 경향이 있습니다. 갈등이 생겨도 감정적으로 바로 반응하기보다 상황을 먼저 정리하려 할 때가 많고, 상대가 왜 그런 반응을 보였는지 이해하려는 경우가 많습니다. 다만 관계를 반드시 유지해야 한다고 생각하기보다는 상황이 맞지 않다고 느껴지면 관계를 정리하는 선택을 하기도 합니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "상황을 객관적으로 판단하려는 태도는 장점이지만 상대에게는 갑작스럽게 관계가 멀어지는 것처럼 느껴질 수 있습니다. 그래서 관계를 정리하거나 거리를 둘 때는 이유를 충분히 설명하는 것이 도움이 될 수 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 이해와 자율성을 중요하게 생각합니다. 상대의 감정을 이해하려는 태도는 있지만 관계를 유지하기 위해 스스로를 억지로 맞추는 상황은 부담스럽게 느끼는 경우가 많습니다.",
        "psychological_basis": "이 유형은 감정을 솔직하게 이야기할 수 있으면서도 서로에게 지나치게 의존하지 않는 관계에서 편안함을 느끼는 경우가 많습니다. 각자의 판단과 선택을 존중하는 관계에서 심리적인 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 감정적으로 거리를 두는 사람처럼 보일 수 있습니다. 상대의 감정을 이해하면서도 관계를 오래 붙잡지 않는 모습 때문에 차갑거나 계산적인 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 이해심이 있으면서도 냉정한 사람으로 보일 수 있습니다. 상대의 감정을 잘 이해하면서도 필요할 때는 거리를 둘 수 있는 모습 때문에 이성적이고 판단이 분명한 사람으로 느껴지는 경우도 있습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HMH",
      "name": "Type HMH",
      "summary": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 평정심을 잘 유지하며 안정적인 장점을 살리되, 적절한 공감과 객관성 유지한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 평정심을 잘 유지하며 안정적함과 관계의 관계를 끈기 있게 유지한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 적절한 공감과 객관성 유지함을 존중하면서도 관계를 끈기 있게 유지한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 평정심을 잘 유지하며 안정적인 면이 강조되어 적절한 공감과 객관성 유지한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 평정심을 잘 유지하며 안정적이면서도 적절한 공감과 객관성 유지한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HMM",
      "name": "Type HMM",
      "summary": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 평정심을 잘 유지하며 안정적인 장점을 살리되, 적절한 공감과 객관성 유지한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 평정심을 잘 유지하며 안정적함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 적절한 공감과 객관성 유지함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 평정심을 잘 유지하며 안정적인 면이 강조되어 적절한 공감과 객관성 유지한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 평정심을 잘 유지하며 안정적이면서도 적절한 공감과 객관성 유지한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HML",
      "name": "Type HML",
      "summary": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 관계를 상황에 따라 판단하려는 경향이 있습니다. 갈등이 생겨도 감정적으로 크게 흔들리기보다 상황을 정리하고 현실적으로 판단하려는 경우가 많습니다. 그래서 관계가 맞지 않는다고 느껴지면 굳이 오래 유지하려 하기보다 정리하는 선택을 하기도 합니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 관계를 상황에 따라 판단하려는 경향이 있습니다. 갈등이 생겨도 감정적으로 크게 흔들리기보다 상황을 정리하고 현실적으로 판단하려는 경우가 많습니다. 그래서 관계가 맞지 않는다고 느껴지면 굳이 오래 유지하려 하기보다 정리하는 선택을 하기도 합니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "상황을 객관적으로 판단하는 태도는 장점이지만 관계를 너무 빠르게 정리하는 선택을 하면 충분히 풀 수 있었던 문제까지 놓치게 될 수 있습니다. 그래서 관계를 판단하기 전에 서로의 입장을 충분히 이야기해 보는 것이 도움이 될 수 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 자율성과 현실적인 관계를 중요하게 생각합니다. 관계를 억지로 유지하기보다 서로에게 의미가 있는 관계를 유지하는 것을 더 중요하게 여기는 경우가 많습니다.",
        "psychological_basis": "이 유형은 감정적으로 크게 흔들리지 않고 각자의 선택과 판단이 존중되는 관계에서 편안함을 느끼는 경우가 많습니다. 서로에게 지나치게 의존하지 않고 각자의 삶을 유지할 수 있는 관계에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 관계를 쉽게 정리하는 사람처럼 보일 수도 있습니다. 상황을 현실적으로 판단하려는 모습 때문에 차갑거나 거리감 있는 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 차분하고 현실적인 사람으로 보일 가능성이 큽니다. 감정에 크게 휘둘리지 않고 상황을 침착하게 바라보는 모습 때문에 이성적인 사람이라는 인상을 줄 때도 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HLH",
      "name": "Type HLH",
      "summary": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 관계를 쉽게 포기하지 않으려는 경향이 있습니다. 갈등이 생겨도 감정적으로 크게 흔들리기보다 상황을 정리하고 문제를 해결하려는 태도를 보일 때가 많습니다. 그래서 관계에서 문제가 생겨도 쉽게 포기하기보다 해결하려는 방향으로 움직이는 경우가 많습니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 상황에서도 비교적 침착하게 반응하면서 관계를 쉽게 포기하지 않으려는 경향이 있습니다. 갈등이 생겨도 감정적으로 크게 흔들리기보다 상황을 정리하고 문제를 해결하려는 태도를 보일 때가 많습니다. 그래서 관계에서 문제가 생겨도 쉽게 포기하기보다 해결하려는 방향으로 움직이는 경우가 많습니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "문제를 해결하려는 태도는 장점이지만 상대가 감정적인 공감을 필요로 하는 상황에서는 충분히 이해받지 못한다고 느낄 수도 있습니다. 그래서 문제 해결뿐 아니라 상대의 감정을 먼저 공감하려는 태도가 필요할 때도 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 신뢰와 책임 있는 관계를 중요하게 생각합니다. 감정 표현이 많지 않더라도 서로 약속을 지키고 관계를 유지하려는 태도를 더 중요하게 보는 경우가 많습니다.",
        "psychological_basis": "이 유형은 감정이 크게 흔들리지 않고 서로 역할과 책임이 분명한 관계에서 편안함을 느끼는 경우가 많습니다. 문제를 함께 해결하고 관계를 안정적으로 유지하려는 환경에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 감정을 잘 표현하지 않는 사람처럼 보일 수도 있습니다. 상대의 감정을 이해하기보다 문제를 해결하려는 모습이 먼저 나타날 수 있기 때문에 차갑거나 무뚝뚝한 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 차분하고 책임감 있는 사람으로 보일 가능성이 큽니다. 감정이 크게 흔들리지 않고 관계를 쉽게 포기하지 않는 모습 때문에 믿을 수 있는 사람이라는 인상을 줄 때가 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HLM",
      "name": "Type HLM",
      "summary": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 평정심을 잘 유지하며 안정적인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 평정심을 잘 유지하며 안정적함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 평정심을 잘 유지하며 안정적인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 평정심을 잘 유지하며 안정적이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "HLL",
      "name": "Type HLL",
      "summary": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 평정심을 잘 유지하며 안정적인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 평정심을 잘 유지하며 안정적인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 평정심을 잘 유지하며 안정적함과 관계의 상황에 맞게 거리를 두는 편한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 상황에 맞게 거리를 두는 편한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 평정심을 잘 유지하며 안정적인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 평정심을 잘 유지하며 안정적이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MHH",
      "name": "Type MHH",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 타인의 감정을 깊게 공감한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 관계를 끈기 있게 유지한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 타인의 감정을 깊게 공감함을 존중하면서도 관계를 끈기 있게 유지한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 타인의 감정을 깊게 공감한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 타인의 감정을 깊게 공감한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MHM",
      "name": "Type MHM",
      "summary": "당신은 상대의 감정을 비교적 잘 이해하면서도 관계를 상황에 맞게 조율하려는 경향이 있습니다. 상대의 기분이나 분위기 변화를 빠르게 알아차리는 경우가 많고, 갈등이 생기면 감정적으로 반응하기보다 대화를 통해 상황을 풀어보려 하는 경우가 많습니다. 그래서 관계에서 문제가 생겨도 바로 거리를 두기보다는 서로의 입장을 이해하려는 방향으로 움직이는 편입니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상대의 감정을 비교적 잘 이해하면서도 관계를 상황에 맞게 조율하려는 경향이 있습니다. 상대의 기분이나 분위기 변화를 빠르게 알아차리는 경우가 많고, 갈등이 생기면 감정적으로 반응하기보다 대화를 통해 상황을 풀어보려 하는 경우가 많습니다. 그래서 관계에서 문제가 생겨도 바로 거리를 두기보다는 서로의 입장을 이해하려는 방향으로 움직이는 편입니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "상대의 감정을 이해하려는 태도는 장점이지만 모든 상황을 맞추려 하면 자신의 생각이나 감정이 뒤로 밀릴 수 있습니다. 그래서 관계를 유지하는 것뿐 아니라 자신의 기준이나 생각을 표현하는 것도 중요할 때가 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 이해와 조율이 가능한 관계를 중요하게 생각합니다. 누가 옳은지보다 서로의 입장을 이해하고 균형을 찾는 관계를 더 선호하는 편입니다.",
        "psychological_basis": "이 유형은 서로의 감정을 솔직하게 이야기할 수 있는 관계에서 편안함을 느끼는 경우가 많습니다. 갈등이 생겨도 대화를 통해 풀 수 있고 서로의 입장을 이해하려는 분위기가 있는 관계에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 모든 상황을 맞춰주는 사람처럼 보일 수도 있습니다. 상대의 감정을 고려하려는 모습이 강하다 보니 자기 의견이 없는 사람처럼 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 이해심이 있는 사람으로 보일 가능성이 큽니다. 상대의 감정을 잘 살피는 모습 때문에 편안하게 이야기할 수 있는 사람으로 느껴지는 경우도 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MHL",
      "name": "Type MHL",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 타인의 감정을 깊게 공감한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 상황에 맞게 거리를 두는 편한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 타인의 감정을 깊게 공감함을 존중하면서도 상황에 맞게 거리를 두는 편한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 타인의 감정을 깊게 공감한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 타인의 감정을 깊게 공감한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MMH",
      "name": "Type MMH",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 적절한 공감과 객관성 유지한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 관계를 끈기 있게 유지한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 적절한 공감과 객관성 유지함을 존중하면서도 관계를 끈기 있게 유지한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 적절한 공감과 객관성 유지한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 적절한 공감과 객관성 유지한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MMM",
      "name": "Type MMM",
      "summary": "당신은 관계에서 상황에 맞게 반응하고 균형을 유지하려는 경향이 있습니다. 감정이 올라오는 상황에서는 순간적으로 흔들릴 수 있지만 시간이 지나면 상황을 정리하려는 경우가 많습니다. 그래서 갈등이 생기더라도 감정적으로만 반응하기보다 상황을 이해하고 조정하려는 방향으로 움직이는 편입니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 관계에서 상황에 맞게 반응하고 균형을 유지하려는 경향이 있습니다. 감정이 올라오는 상황에서는 순간적으로 흔들릴 수 있지만 시간이 지나면 상황을 정리하려는 경우가 많습니다. 그래서 갈등이 생기더라도 감정적으로만 반응하기보다 상황을 이해하고 조정하려는 방향으로 움직이는 편입니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "상황을 맞추려는 태도는 장점이지만 자신의 생각이나 감정을 계속 뒤로 미루면 관계에서 자신의 위치가 흐려질 수 있습니다. 그래서 때로는 상황을 맞추는 것보다 자신의 생각을 분명하게 표현하는 것이 필요할 때도 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 균형과 안정적인 관계를 중요하게 생각합니다. 누가 옳은지보다 관계를 무리 없이 유지할 수 있는 방향을 찾는 것을 더 중요하게 여기는 경우가 많습니다.",
        "psychological_basis": "이 유형은 갈등이 지나치게 크지 않고 서로의 입장을 조율할 수 있는 관계에서 편안함을 느끼는 경우가 많습니다. 감정과 현실 사이에서 균형을 유지할 수 있는 관계에서 심리적인 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 뚜렷한 입장이 없는 사람처럼 보일 수도 있습니다. 상황에 맞게 조정하려는 모습이 강하다 보니 자신의 생각이나 기준이 분명하지 않은 사람처럼 보일 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 무난하고 편안한 사람으로 보일 가능성이 큽니다. 특정 상황에서 극단적으로 반응하기보다 상황에 맞게 행동하려는 모습 때문에 함께 지내기 편한 사람으로 느껴질 때가 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MML",
      "name": "Type MML",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 적절한 공감과 객관성 유지한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 상황에 맞게 거리를 두는 편한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 적절한 공감과 객관성 유지함을 존중하면서도 상황에 맞게 거리를 두는 편한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 적절한 공감과 객관성 유지한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 적절한 공감과 객관성 유지한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MLH",
      "name": "Type MLH",
      "summary": "당신은 관계를 쉽게 포기하지 않으면서도 감정 상황에서는 비교적 현실적으로 판단하려는 경향이 있습니다. 갈등이 생기면 감정적으로 크게 흔들리기보다 문제가 왜 생겼는지 생각해 보거나 상황을 정리하려는 경우가 많습니다. 그래서 관계가 어려워질 때도 바로 거리를 두기보다는 관계를 유지하려는 방향을 먼저 생각하는 편입니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 관계를 쉽게 포기하지 않으면서도 감정 상황에서는 비교적 현실적으로 판단하려는 경향이 있습니다. 갈등이 생기면 감정적으로 크게 흔들리기보다 문제가 왜 생겼는지 생각해 보거나 상황을 정리하려는 경우가 많습니다. 그래서 관계가 어려워질 때도 바로 거리를 두기보다는 관계를 유지하려는 방향을 먼저 생각하는 편입니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "관계를 유지하려는 태도는 장점이지만 감정적인 부분이 충분히 표현되지 않으면 상대가 이해받지 못한다고 느낄 수 있습니다. 그래서 문제를 해결하려는 태도와 함께 상대의 감정을 표현해 주는 노력이 도움이 될 수 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 안정적인 관계와 책임감 있는 태도를 중요하게 생각합니다. 감정 표현이 많지 않더라도 서로 신뢰를 유지하고 관계를 지속하는 것을 더 의미 있게 여기는 경우가 많습니다.",
        "psychological_basis": "이 유형은 서로에게 지나치게 감정적으로 의존하지 않으면서도 관계가 안정적으로 유지되는 환경에서 편안함을 느끼는 경우가 많습니다. 서로의 역할과 책임이 어느 정도 분명한 관계에서 심리적인 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 감정을 잘 드러내지 않는 사람처럼 보일 수도 있습니다. 상대의 감정을 깊게 공감하기보다 상황을 현실적으로 바라보는 모습 때문에 무심하거나 거리감 있는 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 차분하고 안정적인 사람으로 보일 가능성이 큽니다. 감정에 크게 휘둘리지 않으면서도 관계를 쉽게 포기하지 않는 모습 때문에 믿을 수 있는 사람으로 느껴질 때가 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MLM",
      "name": "Type MLM",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "MLL",
      "name": "Type MLL",
      "summary": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상황에 따라 유연하게 대처인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 상황에 따라 유연하게 대처인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 상황에 따라 유연하게 대처함과 관계의 상황에 맞게 거리를 두는 편한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 상황에 맞게 거리를 두는 편한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 상황에 따라 유연하게 대처인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 상황에 따라 유연하게 대처이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LHH",
      "name": "Type LHH",
      "summary": "당신은 상대의 감정을 깊게 이해하면서도 관계를 쉽게 포기하지 않으려는 경향이 있습니다. 상대의 기분 변화나 분위기에 영향을 받는 경우가 많고, 누군가 힘들어하거나 관계가 흔들리는 상황이 생기면 그 문제를 함께 해결하려고 하는 경우가 많습니다. 그래서 관계가 어려워질 때도 쉽게 거리를 두기보다는 관계를 유지하려는 방향으로 움직이는 경향이 있습니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 상대의 감정을 깊게 이해하면서도 관계를 쉽게 포기하지 않으려는 경향이 있습니다. 상대의 기분 변화나 분위기에 영향을 받는 경우가 많고, 누군가 힘들어하거나 관계가 흔들리는 상황이 생기면 그 문제를 함께 해결하려고 하는 경우가 많습니다. 그래서 관계가 어려워질 때도 쉽게 거리를 두기보다는 관계를 유지하려는 방향으로 움직이는 경향이 있습니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "상대의 감정을 이해하려는 태도는 장점이지만 관계의 문제를 혼자 책임지려는 상황이 반복되면 감정적으로 지치거나 소진될 수 있습니다. 그래서 관계가 어려워질 때는 모든 문제를 스스로 해결하려 하기보다 상대와 역할을 나누는 것이 도움이 될 수 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 감정적 연결과 관계의 지속성을 중요하게 생각합니다. 관계를 가볍게 이어가기보다는 서로의 감정을 이해하고 관계를 오래 이어가는 것을 더 의미 있게 느끼는 경우가 많습니다.",
        "psychological_basis": "이 유형은 서로의 감정을 솔직하게 표현할 수 있는 관계에서 편안함을 느끼는 경우가 많습니다. 감정을 숨기기보다 서로 공감하고 이야기할 수 있는 환경에서 관계의 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 감정에 지나치게 몰입하는 사람처럼 보일 수도 있습니다. 상대의 감정이나 관계 문제에 깊이 관여하는 모습 때문에 의존적이거나 감정적으로 흔들리는 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 따뜻하고 헌신적인 사람으로 보일 가능성이 큽니다. 상대의 감정을 잘 이해하고 관계를 쉽게 포기하지 않는 모습 때문에 정이 많고 진심으로 관계를 대하는 사람으로 느껴질 때가 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LHM",
      "name": "Type LHM",
      "summary": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 감정 신호에 민감하고 빠르게 반응인 장점을 살리되, 타인의 감정을 깊게 공감한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 감정 신호에 민감하고 빠르게 반응함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 타인의 감정을 깊게 공감함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 감정 신호에 민감하고 빠르게 반응인 면이 강조되어 타인의 감정을 깊게 공감한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 감정 신호에 민감하고 빠르게 반응이면서도 타인의 감정을 깊게 공감한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LHL",
      "name": "Type LHL",
      "summary": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 타인의 감정을 깊게 공감인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 상황에 맞게 거리를 두는 편인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 감정 신호에 민감하고 빠르게 반응인 장점을 살리되, 타인의 감정을 깊게 공감한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 감정 신호에 민감하고 빠르게 반응함과 관계의 상황에 맞게 거리를 두는 편한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 타인의 감정을 깊게 공감함을 존중하면서도 상황에 맞게 거리를 두는 편한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 감정 신호에 민감하고 빠르게 반응인 면이 강조되어 타인의 감정을 깊게 공감한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 감정 신호에 민감하고 빠르게 반응이면서도 타인의 감정을 깊게 공감한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LMH",
      "name": "Type LMH",
      "summary": "당신은 관계가 흔들리는 상황에서도 쉽게 포기하기보다 관계를 계속 이어가려는 경향이 있습니다. 감정이 올라오는 상황에서는 마음이 쉽게 흔들리는 편이지만 문제가 생기면 관계를 유지하려는 방향을 먼저 생각하는 경우가 많습니다. 그래서 갈등이 생겨도 거리를 두기보다 관계를 이어가려는 선택을 하는 경우가 많습니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 관계가 흔들리는 상황에서도 쉽게 포기하기보다 관계를 계속 이어가려는 경향이 있습니다. 감정이 올라오는 상황에서는 마음이 쉽게 흔들리는 편이지만 문제가 생기면 관계를 유지하려는 방향을 먼저 생각하는 경우가 많습니다. 그래서 갈등이 생겨도 거리를 두기보다 관계를 이어가려는 선택을 하는 경우가 많습니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "관계를 유지하려는 태도는 장점이지만 문제가 반복될 때도 계속 버티는 상황이 생길 수 있습니다. 그래서 관계를 지키는 것뿐 아니라 상황을 객관적으로 판단하는 것도 필요할 때가 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 관계의 지속성과 정서적인 연결을 중요하게 생각합니다. 관계를 쉽게 정리하기보다 서로의 감정을 이해하고 관계를 이어가는 것을 더 의미 있게 느끼는 경우가 많습니다.",
        "psychological_basis": "이 유형은 서로의 감정을 솔직하게 표현하면서도 관계가 쉽게 끊어지지 않는 환경에서 편안함을 느끼는 경우가 많습니다. 서로 감정을 이해하려 노력하면서 관계를 이어가는 관계에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 감정에 쉽게 흔들리는 사람처럼 보일 수도 있습니다. 관계를 유지하려는 의지가 강하다 보니 상대에게 지나치게 맞추는 사람처럼 보일 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 정이 많고 관계를 중요하게 생각하는 사람으로 보일 가능성이 큽니다. 관계를 쉽게 포기하지 않는 모습 때문에 진심으로 관계를 대하는 사람으로 느껴질 때도 많습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LMM",
      "name": "Type LMM",
      "summary": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 적절한 공감과 객관성 유지인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 감정 신호에 민감하고 빠르게 반응인 장점을 살리되, 적절한 공감과 객관성 유지한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 감정 신호에 민감하고 빠르게 반응함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 적절한 공감과 객관성 유지함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 감정 신호에 민감하고 빠르게 반응인 면이 강조되어 적절한 공감과 객관성 유지한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 감정 신호에 민감하고 빠르게 반응이면서도 적절한 공감과 객관성 유지한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LML",
      "name": "Type LML",
      "summary": "당신은 감정 상황에서 영향을 받는 경우가 있지만 관계를 꼭 유지해야 한다고 생각하기보다는 상황에 따라 거리를 두려는 경향이 있습니다. 갈등이 생기면 감정적으로 흔들리는 경우도 있지만 문제를 오래 붙잡기보다는 시간이 지나면 자연스럽게 정리하려는 경우가 많습니다. 그래서 관계가 맞지 않는다고 느껴지면 굳이 오래 유지하기보다 거리를 두는 선택을 하기도 합니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 상황에서 영향을 받는 경우가 있지만 관계를 꼭 유지해야 한다고 생각하기보다는 상황에 따라 거리를 두려는 경향이 있습니다. 갈등이 생기면 감정적으로 흔들리는 경우도 있지만 문제를 오래 붙잡기보다는 시간이 지나면 자연스럽게 정리하려는 경우가 많습니다. 그래서 관계가 맞지 않는다고 느껴지면 굳이 오래 유지하기보다 거리를 두는 선택을 하기도 합니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "관계를 자연스럽게 두려는 태도는 장점이지만 문제가 생길 때마다 거리를 두는 선택이 반복되면 관계가 깊어지기 어려울 수 있습니다. 그래서 중요한 관계에서는 상황을 정리하고 대화를 시도하는 노력이 필요할 때도 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 자유로운 관계와 개인의 선택을 중요하게 생각합니다. 관계를 유지하기 위한 의무나 역할보다 서로 자연스럽게 이어지는 관계를 더 편안하게 느끼는 경우가 많습니다.",
        "psychological_basis": "이 유형은 서로에게 지나치게 얽매이지 않는 관계에서 편안함을 느끼는 경우가 많습니다. 각자의 공간과 선택이 존중되는 환경에서 심리적인 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 관계를 진지하게 생각하지 않는 사람처럼 보일 수도 있습니다. 감정이 흔들리더라도 관계를 오래 붙잡지 않는 모습 때문에 책임감이 부족한 사람으로 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 자유롭고 가벼운 사람으로 보일 가능성이 있습니다. 상황에 크게 얽매이지 않고 자신의 감정과 흐름을 따르는 모습 때문에 편안하고 부담 없는 사람으로 느껴질 때도 있습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LLH",
      "name": "Type LLH",
      "summary": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계를 끈기 있게 유지인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 감정 신호에 민감하고 빠르게 반응인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 감정 신호에 민감하고 빠르게 반응함과 관계의 관계를 끈기 있게 유지한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 관계를 끈기 있게 유지한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 감정 신호에 민감하고 빠르게 반응인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 감정 신호에 민감하고 빠르게 반응이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LLM",
      "name": "Type LLM",
      "summary": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 감정 신호에 민감하고 빠르게 반응인 태도를 보이면서도 현실적이고 독립적인 판단인 면모를 가지고 있습니다. 관계의 지속성에 대해서는 관계의 균형 중시인 성향을 나타내어 독특한 균형을 이룹니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "자신의 감정 신호에 민감하고 빠르게 반응인 장점을 살리되, 현실적이고 독립적인 판단한 소통에 더 신경 쓴다면 관계가 더욱 풍성해질 것입니다."
        ]
      },
      "academic_report": {
        "core_driver": "내면의 감정 신호에 민감하고 빠르게 반응함과 관계의 관계의 균형 중시한 조화를 중요하게 여깁니다.",
        "psychological_basis": "서로의 현실적이고 독립적인 판단함을 존중하면서도 관계의 균형 중시한 신뢰가 유지되는 환경에서 편안함을 느낍니다.",
        "multidimensional_analysis": "때로는 감정 신호에 민감하고 빠르게 반응인 면이 강조되어 현실적이고 독립적인 판단한 의도가 충분히 전달되지 않을 수도 있습니다.",
        "social_role": "주변 사람들에게는 감정 신호에 민감하고 빠르게 반응이면서도 현실적이고 독립적인 판단한 사람으로 인식되기 쉽습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    },
    {
      "type_code": "LLL",
      "name": "Type LLL",
      "summary": "당신은 관계에서 상황에 크게 얽매이기보다 자유로운 흐름을 따르려는 경향이 있습니다. 감정이 올라오는 상황에서도 그것을 오래 붙잡기보다는 그때그때 느끼는 감정이나 상황에 따라 움직이는 경우가 많고, 관계를 유지해야 한다는 책임감보다는 지금 느끼는 감정과 경험을 더 중요하게 생각하는 편입니다. 그래서 관계에서 문제가 생겨면 굳이 갈등을 오래 끌기보다 거리 두기를 선택하는 경우도 나타날 수 있습니다.",
      "depth_psychology": {
        "title": "심층 심리 분석",
        "content": "당신은 관계에서 상황에 크게 얽매이기보다 자유로운 흐름을 따르려는 경향이 있습니다. 감정이 올라오는 상황에서도 그것을 오래 붙잡기보다는 그때그때 느끼는 감정이나 상황에 따라 움직이는 경우가 많고, 관계를 유지해야 한다는 책임감보다는 지금 느끼는 감정과 경험을 더 중요하게 생각하는 편입니다. 그래서 관계에서 문제가 생겨면 굳이 갈등을 오래 끌기보다 거리 두기를 선택하는 경우도 나타날 수 있습니다."
      },
      "advice": {
        "title": "성장을 위한 제언",
        "content": [
          "관계를 자연스럽게 두려는 태도는 장점이 될 수 있지만, 중요한 문제까지 그대로 흘려보내면 관계가 점점 멀어질 수 있습니다. 가끔은 상황을 정리하거나 상대의 입장을 확인하려는 노력이 필요할 때도 있습니다."
        ]
      },
      "academic_report": {
        "core_driver": "이 유형의 사람들은 보통 자유와 자연스러운 관계를 중요하게 생각합니다. 관계를 유지하기 위한 규칙이나 역할보다 서로 편안하게 존재할 수 있는 관계를 선호하는 경우가 많습니다.",
        "psychological_basis": "이 유형은 서로를 크게 구속하지 않는 관계에서 편안함을 느끼는 경우가 많습니다. 각자의 공간과 시간을 존중하면서 필요할 때 자연스럽게 만나는 관계에서 안정감을 느끼는 편입니다.",
        "multidimensional_analysis": "하지만 이런 태도는 때로 관계를 진지하게 생각하지 않는 사람처럼 보일 수도 있습니다. 감정에 크게 집착하지 않는 모습이 무관심하거나 책임을 회피하는 것처럼 오해될 가능성도 있습니다.",
        "social_role": "이런 태도 때문에 주변 사람들에게는 자유롭고 가벼운 사람으로 보일 수 있습니다. 상황에 크게 얽매이지 않는 모습 때문에 편안하고 부담이 없는 사람으로 느껴질 때도 있습니다.",
        "growth_trajectory": "안정적인 성장을 위해 꾸준히 자신을 돌아보는 과정이 필요합니다."
      }
    }
  ]
};
